export default __webpack_public_path__ + "static/media/mc_realization.6e2e056d.mp4";